<div class="sidebar-outer">
    <a class="logo d-flex align-items-center" routerLink="/" (click)="closeSubMenus()" *ngIf="settings.theme.sidebarIsFixed">
        <img src="assets/img/logos/header-logo.long.png">
    </a>
    <app-vertical-menu [menuItems]="menuItems">></app-vertical-menu>    
</div>